<template>
  <div class="main main__container">
    <oie-breadcrumb :items="[{id: 'start', url: '/start', name: 'Start'}, {id: 'register', url: '/registrering', name: 'registrering'}]"></oie-breadcrumb>
    <div class="block__header-smaller">
      Send order request
    </div>
    <p class="block__text block__text--margin">
      With this form you can send an order request for the products in your cart. We will contact you as soon as possible.
    </p>

    <oie-layout-grid class="grid--two grid--order-request">
      <div class="input-column">
        <div class="input-column__container">
          <oie-base-input id="order-request-private-name" label-text="Name" placeholder="Your first and lastname"></oie-base-input>

          <oie-base-input id="order-request-company-number" label-text="Phonenumber" placeholder="Your phonenumber"></oie-base-input>

          <oie-base-input id="order-request-email" label-text="Email" placeholder="Your email"></oie-base-input>

          <oie-base-input id="order-request-address" label-text="Street" placeholder="Your street"></oie-base-input>

          <oie-base-input id="order-request-address-postal" label-text="Zip" placeholder="Your zip code"></oie-base-input>

          <oie-base-input id="order-request-address-city" label-text="City" placeholder="Your city"></oie-base-input>

          <oie-base-input id="order-request-address-country" label-text="Country" placeholder="Your country"></oie-base-input>

          <oie-base-input
            id="order-request-message"
            label-text="Message"
            placeholder="Your message"
            :textarea="true"
            :max-length="2000"></oie-base-input>
        </div>
      </div>

      <div class="input-column">
      </div>
    </oie-layout-grid>

    <div class="history-details-products">
      <div class="history-details-products__top">
        Summary of cart

        <router-link to="/" class="order-request__edit-cart">
          Edit cart
        </router-link>
      </div>

      <oie-order-request-product-table class="history-details-products__table"></oie-order-request-product-table>

      <div class="history-details-products__summary">
        <div class="history-details-products__summary-row">
          Betalningt exklusive moms
          <div class="history-details-products__summary-value">
            0kr
          </div>
        </div>

        <div class="history-details-products__summary-row">
          Fraktkostnad exklusive moms
          <div class="history-details-products__summary-value">
            250kr
          </div>
        </div>

        <div class="history-details-products__summary-row">
          Moms
          <div class="history-details-products__summary-value">
            300kr
          </div>
        </div>

        <div class="history-details-products__summary-row">
          Totalt (inklusive frakt och betalningsavgift)
          <div class="history-details-products__summary-value history-details-products__summary-value--larger">
            6900kr
          </div>
        </div>
      </div>

      <oie-base-button text="Send request" css-classes="button--with-border button--green"></oie-base-button>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    isCompanyCustomer: null
  })
}
</script>

<style lang="scss">
.grid--order-request {
  margin-bottom: measure(full);
}

.order-request__edit-cart {
  @include body-semi-bold;
  color: color(text);
  text-decoration: none;
  margin-left: auto;

  &:hover {
    text-decoration: underline;
  }
}

.order-request__dropdown {
  border: 1px solid #DFDFDF;
}
</style>
